import React, { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMark } from '@lyearn/icons';
import { Box, Divider, Typography } from '@lyearn/ui';
import AutocompleteSearch from '@/components/AutocompleteSearch';
import { FolderItem } from '@/modules/tasks/views/TasksDashboard/types';

import { FolderSearchProps } from './types';

export const classes = {
  listbox: 'p-8 max-h-[22.4rem]',
};

function FolderSearch({ folderId, onChange }: FolderSearchProps) {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState<string>('');
  const folders = [] as FolderItem[];

  return (
    <AutocompleteSearch
      classes={classes}
      data={folders}
      fetchMore={undefined}
      getTextFromValue={(value: FolderItem | null) => value?.name ?? ''}
      placeholder={t('Task:Folder.FolderSearchPlaceholder')}
      renderers={{
        renderGroup: (params) => (
          <Box key={params.key} className="mt-8">
            <Typography className="ps-12" color="text-text-primary" variant="label-02">
              {params.group}
            </Typography>
            <Divider className="mt-8 mb-4" />
            {params.children}
          </Box>
        ),
        renderOption: (item: FolderItem) => {
          const isSelected = item.id === folderId;
          return (
            <Box className="mb-2 flex w-full items-center justify-between py-10 px-12">
              <Typography
                color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
                variant="body-short-02">
                {item.name}
              </Typography>
              {isSelected ? <CheckMark className="h-20 w-20" fillColorToken="icon-active" /> : null}
            </Box>
          );
        },
      }}
      size="large"
      onChange={onChange}
      onInputChange={setSearchText}
    />
  );
}

export default FolderSearch;
